import DSCircularProgress from '../../../design-system/DSCircularProgress';
import DSBox from '../../../design-system/DSBox';
import { DSTypography } from '../../../design-system/Typography';
import PlanCard from './PlanCard';
import { usePlanByIdQuery } from '../hooks/usePlansQuery';

type MonetizationTabProps = {
  planId?: string;
};

const MonetizationTab = ({ planId }: MonetizationTabProps) => {
  const { data: plan, isLoading } = usePlanByIdQuery(planId ?? null);

  if (isLoading) {
    return (
      <DSBox sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <DSCircularProgress size={24} />
      </DSBox>
    );
  }

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        width: '80%',
        p: 3,
      }}
    >
      {plan ? (
        <DSBox
          sx={{ display: 'flex', height: '291px', width: 'calc(80% / 3)' }}
        >
          <PlanCard plan={plan} selected={false} />
        </DSBox>
      ) : (
        <DSTypography variant="body1" color="text.secondary">
          No monetization model assigned yet.
        </DSTypography>
      )}
    </DSBox>
  );
};

export default MonetizationTab;
